import { render, staticRenderFns } from "./SegmentationRow.vue?vue&type=template&id=227f8152&scoped=true&"
import script from "./SegmentationRow.vue?vue&type=script&lang=js&"
export * from "./SegmentationRow.vue?vue&type=script&lang=js&"
import style0 from "./SegmentationRow.vue?vue&type=style&index=0&id=227f8152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227f8152",
  null
  
)

export default component.exports